import Vue from 'vue'
import Vuex from 'vuex'
import apiService from '@/services/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cars: [],
    carImages: [],
    selectedCar: {},
    loading: false,
    error: null
  },
  getters: {
    getAllCars: state => state.cars,
    getSelectedCar: state => state.selectedCar[0],
    getSelectedCarImages: state => state.selectedCar[0]?.Images || [],
    isLoading: state => state.loading,
    getError: state => state.error
  },
  mutations: {
    setAllCars: (state, payload) => { state.cars = payload },
    setSelCar: (state, payload) => {
      state.selectedCar = state.cars.filter(ca => ca.refnum === payload)
    },
    setLoading: (state, loading) => { state.loading = loading },
    setError: (state, error) => { state.error = error },
    updateRadius: (state, rad) => { state.radius = rad }
  },
  actions: {
    async fetchAllCars({ commit }, filters = {}) {
      commit('setLoading', true)
      commit('setError', null)
      try {
        const cars = await apiService.getAllCars(filters)
        commit('setAllCars', cars)
      } catch (error) {
        commit('setError', error.message)
        console.error('Error fetching cars:', error)
      } finally {
        commit('setLoading', false)
      }
    },
    async fetchCarByRefnum({ commit, state }, refnum) {
      commit('setLoading', true)
      commit('setError', null)
      try {
        // If cars are already loaded, use them
        if (state.cars.length > 0) {
          commit('setSelCar', refnum)
        } else {
          // Otherwise fetch from API
          const car = await apiService.getCarByRefnum(refnum)
          commit('setAllCars', [car])
          commit('setSelCar', refnum)
        }
      } catch (error) {
        commit('setError', error.message)
        console.error('Error fetching car:', error)
      } finally {
        commit('setLoading', false)
      }
    }
  },
  modules: {
  }
})
